export const FORM_FIELD_NAME = {
  TYPE: 'type',
  NAME: 'name',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  NICK_NAME: 'nickname',
  ACCOUNT_TYPE: 'accountType',
  ACCOUNT_NUMBER: 'accountNumber',
  CONFIRM_ACCOUNT_NUMBER: 'confirmAccountNumber',
  ROUTING_NUMBER: 'routingNumber',
  INSTITUTION_NAME: 'institutionName',
  ACCOUNT_NUMBER_ERROR: 'accountNumberError',
  ROUTING_NUMBER_ERROR: 'routingNumberError',
  CONFIRM_ACCOUNT_NUMBER_ERROR: 'confirmAccountNumberError',
  WIRE_ROUTING_NUMBER: 'wireRoutingNumber',
  WIRE_INSTITUTION_NAME: 'wireInstitutionName',
  WIRE_ROUTING_NUMBER_ERROR: 'wireRoutingNumberError'
};
